<template>
  <div class="video-player-container">
    <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto" :poster="poster" :width="width" :height="height" data-setup="{}">
      <source :src="src" :type="computedType" />
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
      </p>
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// Import HTTP streaming module for HLS support
import '@videojs/http-streaming';

export default {
  name: 'VideoPlayer',
  props: {
    src: {
      type: String,
      required: true,
      default:
        'https://cdn.app.flashy-staging.ae/323/e72c8aa4-dae3-495b-bd1f-54932950c851/hls/stream.m3u8?Expires=1746528900&Key-Pair-Id=KX0SRPF5UNKRG&Signature=oNqVF0cXO8kkfqPPdXJ4S38m5LDmhWP27Fu8JBa7RRxXQ~2gDFIWnzUGNzgqd1v8jjqchhBbW7OVknMPlEEglE3GNVISO2w-tlCXEAey8jMepBXGiblYFejxSJ~lXKUHtdxrqLAjnFBwMDr7uSiNKUI-HIqrcCl0sVMCBXgrSB4o-iAAIPZBzcWuLCK-4GtpuTNe5adMkWP3VDhHsJK-tuuoRo9pSzL7G8WX467JabNfzNMI5LD~rRNeQTXP3URC2X9NNF7ZE7TfKBqKgTF6vRVKpRuAH4T5clhsEClslfdqSwuF~e3TWlJxOYKZfotMPWZ1Wn39S2VT0k74~jRzhw__'
    },
    poster: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 640
    },
    height: {
      type: [Number, String],
      default: 360
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    computedType() {
      // If type is provided, use it
      if (this.type) {
        return this.type;
      }

      // Auto-detect type based on file extension
      if (this.src.endsWith('.m3u8')) {
        return 'application/x-mpegURL';
      } else if (this.src.endsWith('.mp4')) {
        return 'video/mp4';
      } else if (this.src.endsWith('.webm')) {
        return 'video/webm';
      } else if (this.src.endsWith('.ogg')) {
        return 'video/ogg';
      }

      // Default to mp4 if can't determine
      return 'application/x-mpegURL';
    }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    console.log('Attempting to load video:', this.src);
    this.initializePlayer();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    initializePlayer() {
      const options = {
        autoplay: false,
        controls: true,
        fluid: true,
        responsive: true,
        playbackRates: [0.5, 1, 1.5, 2],
        html5: {
          vhs: {
            // Changed from hls to vhs - this is the correct property name
            overrideNative: true,
            withCredentials: true // Enable credentials if your stream requires cookies
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        ...this.options
      };

      this.player = videojs(this.$refs.videoPlayer, options, () => {
        this.player.log('Video player initialized');
        this.$emit('ready', this.player);
      });
    }
  }
};
</script>

<style>
.video-player-container {
  width: 100%;
  margin: 0 auto;
}

.video-js {
  width: 100%;
  height: 100%;
}

.vjs-poster {
  background-size: cover;
}
</style>
